// Standalone offer layout — renders child routes (index, customize-landing)

import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/(org)/o/$orgSlug/offers/$offerId")({
  component: () => <Outlet />,
});
